/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: QuarterlyOrdersRoutingModule
 * Purpose		: Routing module for QuarterlyOrders.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { QuarterlyOrdersListComponent } from './QuarterlyOrdersList.component';
import { QuarterlyOrdersDetailsComponent } from './QuarterlyOrdersDetails.component';

const QuarterlyOrdersRoutes: Routes = [
	{ path: 'QuarterlyOrders',  component: QuarterlyOrdersListComponent },
	{ path: 'QuarterlyOrders/Details/:id', component: QuarterlyOrdersDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(QuarterlyOrdersRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class QuarterlyOrdersRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/QuarterlyOrders/QuarterlyOrders-routing.module.ts